
const collator = new Intl.Collator(undefined, {
  sensitivity: "base", // ignore case/accents
  numeric: true, // "2" < "10"
  ignorePunctuation: true,
});

export function sortAsc<T, K extends keyof T>(arr: T[], field: K): T[] {
  return [...arr].sort((a, b) =>
    collator.compare(String(a[field] ?? ""), String(b[field] ?? ""))
  );
}

// optional Z→A
export function sortDesc<T, K extends keyof T>(arr: T[], field: K): T[] {
  return [...arr].sort((a, b) =>
    collator.compare(String(b[field] ?? ""), String(a[field] ?? ""))
  );
}


export function fnv1a32(str: string): number {
  let h = 0x811c9dc5; // FNV offset basis (32-bit)
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    // h *= 16777619 (FNV prime), via shifts to stay in 32-bit
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h >>> 0;
}

export function pickColor(name: string, colors: string[]) {
  // normalize input if you want case/whitespace insensitivity:
  const key = name.trim().toLowerCase();
  const hash = fnv1a32(key);
  return colors[hash % colors.length];
}